import { Component, Input, OnInit } from "@angular/core";
import { Globals } from "src/app/common/globals";
import {
  ExperienceStepModel,
  GeneralExpWizardInfoByLang,
} from "src/app/models/experience-steps.model";
import { LANGUAGE } from "src/app/services/experience/experience-steps.service";

@Component({
  selector: "app-finishing-touches-step",
  templateUrl: "./finishing-touches-step.component.html",
  styleUrls: ["./finishing-touches-step.component.scss"],
})
export class FinishingTouchesStepComponent implements OnInit {
  LANGUAGE = LANGUAGE;

  @Input() step: ExperienceStepModel;
  @Input() generalInfoByLang: GeneralExpWizardInfoByLang;
  @Input() experienceId: string;
  @Input() hasIssue: boolean;
  @Input() hasComments: boolean;
  @Input() comments: Array<any>;
  @Input() experienceOrigin: boolean;
  @Input() experienceOriginUrl: string;

  public categories: Array<any> = Globals.categories;

  constructor() {}

  ngOnInit(): void {
    this.checkStepComplete();
  }

  changeLanguage(lang: string) {
    this.generalInfoByLang.language = lang;
    this.checkStepComplete();
  }

  checkStepComplete() {
    if (
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .title &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .description &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .description &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .typeIndex != null &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .scheduleExperience.length > 0 &&
      this.generalInfoByLang.selectedCoverImage &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .locationAddress &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .longitude &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .latitude
    ) {
      this.step.isComplete = true;
    } else {
      this.step.isComplete = false;
    }
  }
}
